import React, { useEffect } from 'react'
import styles from './styles.css'
import KYCSuccess from './KYC-status-success.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { GET_KYC } from '../Layout'
import { useQuery } from '@apollo/client'
import Button from 'stories/Button'

const Finish = () => {
  const params = useParams()
  const navigate = useNavigate()

  const { data, loading } = useQuery(GET_KYC, {
    pollInterval: 10000,
    variables: { id: params.id },
  })

  useEffect(() => {
    if (data.getKyc.verified) window.location.href = data.getKyc.returnUrl
    if (data.getKyc.rejected) window.location.href = data.getKyc.errorUrl
  }, [data, loading])

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.imgContainer}>
          <img alt="success" src={KYCSuccess} className={styles.image} />
        </div>
        <div className={styles.textContainer}>
          <h1>Estamos verificando tu identidad...</h1>
          <p>
            Este proceso puede tardar unos minutos. Le recomendamos permanecer en esta pantalla
            hasta que el proceso finalice.
          </p>
          <div className={styles.divButton}>
            <Button primary onClick={() => navigate('/')}>
              Inicio
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Finish
